export enum ChannelType {
  WINDOW = 'WINDOW',
  SMARTSTORE = 'SMARTSTORE',
}
